/**
 * Creating Your First Case Tour
 *
 * Guides users through the case creation workflow.
 * Starts on the dashboard and moves to the cases list page.
 */

import type { TourConfig } from './tour-config.types';

export const firstCaseTour: TourConfig = {
  id: 'creating-first-case',
  title: 'tours.firstCase.title',
  portal: 'business',
  steps: [
    {
      target: '[data-astor-id="cases-new-button"]',
      content: 'tours.firstCase.steps.clickNewCase',
      placement: 'bottom',
      route: '/loans',
    },
    {
      target: '[data-astor-id="case-borrower-section"]',
      content: 'tours.firstCase.steps.addBorrower',
      placement: 'bottom',
      route: '/loans/create',
    },
    {
      target: '[data-astor-id="case-settings-section"]',
      content: 'tours.firstCase.steps.configureSettings',
      placement: 'left',
      route: '/loans/create',
    },
    {
      target: '[data-astor-id="cases-data-table"]',
      content: 'tours.firstCase.steps.casesTable',
      placement: 'top',
      route: '/loans',
    },
    {
      target: '[data-astor-id="case-term-sheets-tab"]',
      content: 'tours.firstCase.steps.generateTermSheet',
      placement: 'bottom',
      route: '/loans/term-sheets',
    },
    {
      target: '[data-astor-id="documents-upload-card"]',
      content: 'tours.firstCase.steps.attachDocuments',
      placement: 'right',
      route: '/documents',
    },
  ],
};
